import type { ObservationRecordV1 } from '@gk/contracts'
import type { OverlayRow } from './db.ts'
import type { Projector } from './projectors.ts'
import { localDate } from '../lib/time.ts'

/** M16-N (docs/M16.md rule 2): the projection of observation.record@1, a field FACT. The observation shows on this device at once, pending, on the
 *  club's own day, with what was typed, until the server's row replaces it. The id is the device's own (newId), so a retry duplicates nothing; the
 *  outline in force (area_version_id) is the server's to find, as for the notebook's readings. observation.link_job@1 is the office's intent: no
 *  projection (`none` in the registry). Registered in projectors.ts by Z's close. */
export const observationRecord: Projector = async (cmd, db) => {
  const p = cmd.payload as ObservationRecordV1
  const at = p.observed_at ?? cmd.occurred_at
  const tz = ((await db.site.get(cmd.site_id)) as { timezone?: string } | undefined)?.timezone ?? 'Europe/Paris'
  const row: OverlayRow = {
    key: `ops.observation:${p.observation_id}`, table: 'ops.observation', id: p.observation_id, command_id: cmd.command_id, op: 'insert',
    row: {
      id: p.observation_id, org_id: cmd.org_id, site_id: cmd.site_id, area_id: p.area_id, area_version_id: null, observed_at: at, observed_local_date: localDate(at, tz),
      kind: p.kind, note: p.note?.trim() || null, job_id: null, job_linked_at: null, entered_at: cmd.occurred_at, actor_person_id: cmd.actor_person_id ?? null, _pending: true,
    },
  }
  return [row]
}
